export default {
  testimonial: {
    name: 'Jose Pilay',
    position: 'Líder de Desarrollo en Salica Del Ecuador S.A.',
    country: 'Ecuador',
    picture: 'testimonios/jose-pilay.jpeg',
    text: 'El contenido de sus cursos abarcan todos los temas a tratar, los facilitadores cuentan con experiencia comprobada en la materia.',
  },
};
